import React from "react"

import { getThemeColor } from "./utils"
import CircleCheckIcon from "../../../elements/V2/Icons/CircleCheckIcon"
import Typography from "../../../elements/V2/Typography"

type ListCellProps = {
  items: string[]
  theme: "light" | "dark"
}

const ListCell = ({ items, theme }: ListCellProps) => (
  <div className="flex flex-col gap-0.5 text-start">
    {items.map((item, index) => (
      <div className="flex gap-2" key={`list-${item}-${index}`}>
        <div>
          <CircleCheckIcon
            width={16}
            height={16}
            className={theme === "light" ? "text-charcoal" : "text-white"}
          />
        </div>
        <Typography
          text={item}
          size="body-md"
          font="grotesk"
          weight="book"
          color={getThemeColor(theme)}
        />
      </div>
    ))}
  </div>
)

export default ListCell
